/* global queryString */
/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'

import * as d3 from 'd3'
import cloneDeep from 'lodash/cloneDeep'

import Visual from 'bam-node-evp/dist/Visual'
import SavantModel from 'bam-node-evp/src/Models/SavantModel'

import schemaDefault from 'bam-node-evp/schema/default'
import SaveImage from './Download/index'

import 'bam-node-evp/dist/styles.css'

const schema = cloneDeep(schemaDefault)
schema.chartType = 'field'
schema.selectedChart = 'field'

schema.charts = [
    {
        chartType: 'field',
        overlayType: 'spray',
        legend: true,
        legendType: 'paResult',
    },
]

schema.namePlate.backgroundColor = '#fafafa'
schema.namePlate.background = 'none'

let data = []

let pageWidth = $('#spray').width()

if (pageWidth >= 500) {
    pageWidth = 500
}

const shapeRatio = pageWidth / 500
schema.shapeRatio = shapeRatio

const margin = {
    top: pageWidth * 0.05,
    right: pageWidth * 0.01,
    bottom: pageWidth * 0.07,
    left: pageWidth * 0.08,
}
const width = 500 - margin.left - margin.right
const height = 500 - margin.top - margin.bottom

const yScale = d3.scaleLinear().range([0, height]).domain([80, -80])
const yAxis = d3.axisLeft().scale(yScale)

const xScale = d3.scaleLinear().range([width, 0]).domain([125, 20])
const xAxis = d3.axisBottom().scale(xScale)

const svg = d3.select('#ev_la')
    .append('svg')
    .attr('viewBox', '0 0 500 500')
    .attr('width', pageWidth)
    .attr('height', pageWidth)
    .attr('id', 'svg_ev_la')
    .append('g')
    .attr('id', 'g_ev_la')
    .attr('transform', `translate(${margin.left},${margin.top})`)

const rect = svg
    .append('rect')
    .attr('id', 'rect_ev_la')
    .attr('width', width)
    .attr('height', height)
    .attr('fill', '#f5f5f5')

rect.on('click', (d, i) => {
    console.log('clicked', d)
    clickEvent(d)
})

rect.on('mousemove', (d, i) => {
    moveEvent(d)
})

/* rect.call(
    drag()
        .on("start", function (d, i) {})
        .on("drag", function (d, i) {
            moveEvent(d);
        })
        .on("end", function (d, i) {
            console.log(d);
            clickEvent(d);
        })
); */

svg.append('g')
    .attr('class', 'x axis')
    .attr('transform', `translate(0,${height})`)
    .call(xAxis)
    .append('text')
    .attr('class', 'label')
    .attr('x', width)
    .attr('y', -6)
    .attr('dx', -10)
    .style('text-anchor', 'end')
    .style('fill', '#000')
    .style('font-size', '.8rem')
    .style('font-weight', 'normal')
    .text('Exit Velocity')

// y-axis
svg.append('g')
    .attr('class', 'y axis')
    .call(yAxis)
    .append('text')
    .attr('class', 'label')
    .attr('transform', 'rotate(-90)')
    .attr('y', 6)
    .attr('x', -10)
    .attr('dy', '1em')
    .style('text-anchor', 'end')
    .style('fill', '#000')
    .style('font-size', '.8rem')
    .style('font-weight', 'normal')
    .text('Launch Angle')

$('#save').click(() => {
    $('#save')
        .text('Saving Image...')
        .prop('disabled', true)
        .css('background-color', '#c2c2c2')
    //    schema.shapeRatio = 2;
    SaveImage(
        {
            data,
            player: {},
            schema,
        },
        (err, id) => {
            console.log('Done!')
            $('#save')
                .text('Save Image')
                .prop('disabled', false)
                .css('background-color', '#399098')
        }
    )
})

function clickEvent(event, rawCoords = null) {
    const coords = rawCoords ? rawCoords : d3.pointer(event, svg.node())

    d3.selectAll('.circle_stamp').remove()
    d3.select('#hover-g').remove()

    const hover = d3.select('#g_ev_la')

    hover
        .append('circle')
        .attr('class', 'circle_stamp')
        .attr('cx', coords[0])
        .attr('cy', coords[1])
        .attr('r', 10)
        .style('fill', 'none')
        .style('stroke', '#3a9098')
        .style('stroke-width', 2)

    hover
        .append('circle')
        .attr('class', 'circle_stamp')
        .attr('cx', coords[0])
        .attr('cy', coords[1])
        .attr('r', 2)
        .style('fill', '#3a9098')
        .style('stroke', '#3a9098')

    hover
        .append('line')
        .attr('class', 'circle_stamp')
        .attr('x1', coords[0])
        .attr('x2', coords[0])
        .attr('y1', yScale(-80))
        .attr('y2', coords[1] + 10)
        .attr('stroke', '#b2dfdb')

    hover
        .append('line')
        .attr('class', 'circle_stamp')
        .attr('x1', xScale(20))
        .attr('x2', coords[0] - 10)
        .attr('y1', coords[1])
        .attr('y2', coords[1])
        .attr('stroke', '#b2dfdb')

    const exit_velocity = parseInt(xScale.invert(coords[0]))
    const launch_angle = parseInt(yScale.invert(coords[1]))

    window.history.pushState('', '', `?ev=${exit_velocity}&la=${launch_angle}`)
    getData(exit_velocity, launch_angle)
}

function moveEvent(event) {
    const coords = d3.pointer(event, svg.node())
    d3.select('#hover-g').remove()

    const hover = d3.select('#g_ev_la').append('g').attr('id', 'hover-g')

    hover
        .append('text')
        .attr('class', 'circle_stamp')
        .attr('x', xScale(125))
        .attr('y', yScale(81))
        .attr('text-anchor', 'end')
        .style('font-family', "'Roboto Condensed")
        .text(
            `${String(parseInt(xScale.invert(coords[0])))} MPH, ${String(
                parseInt(yScale.invert(coords[1]))
            )}°`
        )

    hover
        .append('line')
        .attr('x1', coords[0])
        .attr('x2', coords[0])
        .attr('y1', yScale(-80))
        .attr('y2', coords[1] + 10)
        .attr('stroke', '#b00')

    hover
        .append('line')
        .attr('x1', xScale(20))
        .attr('x2', coords[0] - 10)
        .attr('y1', coords[1])
        .attr('y2', coords[1])
        .attr('stroke', '#b00')

    hover
        .append('circle')
        .attr('id', 'circle')
        .attr('cx', coords[0])
        .attr('cy', coords[1])
        .attr('r', 10)
        .style('fill', 'none')
        .style('stroke', '#b00')
}

if (queryString.ev && queryString.la) {
    getData(queryString.ev, queryString.la)
    // Kind of hacky, but it works without crazy effort
    clickEvent({}, [xScale(queryString.ev), yScale(queryString.la)])
}

function getData(exit_velocity, launch_angle) {
    $('#save').hide()
    const el = document.getElementById('spray')
    try {
        ReactDOM.unmountComponentAtNode(el)
        $('#spray').html('<h3 style="text-align: center;">Loading Data...</h3>')
    } catch (ex) {
        console.log('Error')
    }
    $.ajax({
        method: 'GET',
        url: `/statcast_field?exit_velocity=${exit_velocity}&launch_angle=${launch_angle}`,
    }).done((jsonData) => {
        data = jsonData.spray.map((d) => ({
            hc_x_ft: d.hc_x_ft,
            hc_y_ft: d.hc_y_ft,
            hit_speed: d.hit_speed,
            events: d.events,
            balls: d.balls,
            strikes: d.strikes,
            des: d.des,
            px: 1.01,
            pz: 1.01,
            pitch_type: 'NA',
        }))

        schema.namePlate.primaryTitleText = `Exit Velocity: ${exit_velocity} MPH, Launch Angle: ${launch_angle}°`
        schema.namePlate.primaryTitleFontSize = '1.1rem'
        schema.namePlate.secondaryTitleFontSize = '.75rem'
        schema.namePlate.secondaryFontColor = '#b00'
        schema.namePlate.primaryTitleX = 10
        schema.namePlate.secondaryTitleX = 10

        schema.namePlate.supressImage = true
        schema.sourcePlate.sourceTitle = 'promo'
        schema.sourcePlate.siteTitle = 'SPRAY CHART'

        let descText = ''
        if (jsonData.xba && jsonData.xba.length > 0) {
            descText = `BA: ${jsonData.xba[0].ba} 1B%: ${jsonData.xba[0].single_percent} 2B%: ${jsonData.xba[0].double_percent} 3B%: ${jsonData.xba[0].triple_percent} HR %: ${jsonData.xba[0].hr_percent}`
        } else {
            descText = 'No Tracked Records at this Combination'
        }
        schema.namePlate.secondaryTitleText = `${descText}`

        ReactDOM.render(
            <Visual data={SavantModel(schema, data)} chart={schema} />,
            el
        )
        $('#save').show()
    })
}
